import type { ReactNode } from 'react';
import { ADMIN_COLORS, useAnimatedNumber } from '@/features/admin/utils/adminAnimations';

interface StatCardProps {
  icon: ReactNode;
  label: string;
  value: number;
  className?: string;
}

function AnimatedValue({ value }: { value: number }) {
  const d = useAnimatedNumber(value);
  return <>{d.toLocaleString()}</>;
}

export function StatCard({ icon, label, value, className }: StatCardProps) {
  return (
    <div
      className={`flex items-center gap-3 p-3 md:p-4 rounded-xl glass-surface ${className ?? ''}`}
      style={{
        backgroundColor: ADMIN_COLORS.surface,
        border: `1px solid ${ADMIN_COLORS.border}`,
        boxShadow: ADMIN_COLORS.shadow,
      }}
    >
      <div className="w-7 h-7 md:w-8 md:h-8 flex-shrink-0" style={{ color: ADMIN_COLORS.navy + '80' }}>
        {icon}
      </div>
      <div>
        <p className="text-xs font-bold text-slate-500 uppercase">{label}</p>
        <p className="text-2xl font-bold text-slate-800">
          <AnimatedValue value={value} />
        </p>
      </div>
    </div>
  );
}
